import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import NotRepresentableException from './NotRepresentableException';
import Coordinate from '../geom/Coordinate';
import Double from '../../../../java/lang/Double';
var HCoordinate = /*#__PURE__*/function () {
  function HCoordinate() {
    _classCallCheck(this, HCoordinate);
    HCoordinate.constructor_.apply(this, arguments);
  }
  _createClass(HCoordinate, [{
    key: "getY",
    value: function getY() {
      var a = this.y / this.w;
      if (Double.isNaN(a) || Double.isInfinite(a)) throw new NotRepresentableException();
      return a;
    }
  }, {
    key: "getX",
    value: function getX() {
      var a = this.x / this.w;
      if (Double.isNaN(a) || Double.isInfinite(a)) throw new NotRepresentableException();
      return a;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      var p = new Coordinate();
      p.x = this.getX();
      p.y = this.getY();
      return p;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.x = null;
      this.y = null;
      this.w = null;
      if (arguments.length === 0) {
        this.x = 0.0;
        this.y = 0.0;
        this.w = 1.0;
      } else if (arguments.length === 1) {
        var p = arguments[0];
        this.x = p.x;
        this.y = p.y;
        this.w = 1.0;
      } else if (arguments.length === 2) {
        if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
          var _x = arguments[0],
            _y = arguments[1];
          this.x = _x;
          this.y = _y;
          this.w = 1.0;
        } else if (arguments[0] instanceof HCoordinate && arguments[1] instanceof HCoordinate) {
          var p1 = arguments[0],
            p2 = arguments[1];
          this.x = p1.y * p2.w - p2.y * p1.w;
          this.y = p2.x * p1.w - p1.x * p2.w;
          this.w = p1.x * p2.y - p2.x * p1.y;
        } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Coordinate) {
          var _p = arguments[0],
            _p2 = arguments[1];
          this.x = _p.y - _p2.y;
          this.y = _p2.x - _p.x;
          this.w = _p.x * _p2.y - _p2.x * _p.y;
        }
      } else if (arguments.length === 3) {
        var _x2 = arguments[0],
          _y2 = arguments[1],
          _w = arguments[2];
        this.x = _x2;
        this.y = _y2;
        this.w = _w;
      } else if (arguments.length === 4) {
        var _p3 = arguments[0],
          _p4 = arguments[1],
          q1 = arguments[2],
          q2 = arguments[3];
        var px = _p3.y - _p4.y;
        var py = _p4.x - _p3.x;
        var pw = _p3.x * _p4.y - _p4.x * _p3.y;
        var qx = q1.y - q2.y;
        var qy = q2.x - q1.x;
        var qw = q1.x * q2.y - q2.x * q1.y;
        this.x = py * qw - qy * pw;
        this.y = qx * pw - px * qw;
        this.w = px * qy - qx * py;
      }
    }
  }]);
  return HCoordinate;
}();
export { HCoordinate as default };